import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import FormTemplate from '../../dialogs_common/FormTemplate';
import { NewspaperIcon } from '@heroicons/react/24/outline';
import { OutlineButton, SolidButton } from '../../components/Button';
import FormTemplateButtonFooter from '../../dialogs_common/FormTemplateButtonFooter';
import { useQueryMutation } from '../../../hooks/@lore/query-connect';
import { useUser } from '@lore/auth';

export default function OfferConfirmation(props) {
  const {
    onCancel,
    onPrevious,
    onNext
  } = props;

  const currentUser = useUser();

  const mutation = useQueryMutation('offer.create');
  const { saving, success, error, request } = mutation;

  useEffect(() => {
    if (success) {
      onNext(request);
    }
  }, [success]);

  function onSubmit() {
    mutation.mutate({
      creatorId: currentUser.id
    });
  }

  return (
    <FormTemplate
      // className="w-screen max-w-screen-sm"
      icon={(
        <div className="flex justify-center mb-4">
          <NewspaperIcon className="text-cs-orange-500 h-12 w-12" />
        </div>
      )}
      title="Let's create your offer!"
      subtitle={(
        <>
          Partners create offers for educators and students such as internships, field trips,
          and more. They can be scheduled for a specific date or have flexible timing, and they
          can be free or have a cost.
        </>
      )}
      onClose={onCancel}
      footer={(
        <FormTemplateButtonFooter>
          <OutlineButton onClick={onPrevious}>
            Back to options
          </OutlineButton>
          <SolidButton onClick={onSubmit}>
            Create offer
          </SolidButton>
        </FormTemplateButtonFooter>
      )}
    />
  );
}
